const SET_SIDE_NAV_OPEN = "leftpanel/setSideNavOpen";
const SET_SIDE_NAV_COLLAPSIBLE = "leftpanel/setSideNavCollapsible";
const UPDATE_ACTIVE_MENU = "leftpanel/updateActiveMenu";
const SET_SIDE_MENU = "leftpanel/setSideMenu";

export const updateActiveMenu = (payload) => ({
  type: UPDATE_ACTIVE_MENU,
  payload,
});
export const setSideMenu = (payload) => ({ type: SET_SIDE_MENU, payload });
export const setSideNavOpen = (payload) => ({
  type: SET_SIDE_NAV_OPEN,
  payload,
});
export const setSideNavCollapsible = (payload) => ({
  type: SET_SIDE_NAV_COLLAPSIBLE,
  payload,
});

const initialState = {
  activeMenu: null,
  breadcrumbData: null,
  isSideNavOpen: false,
  isSideNavCollapsible: false,
};

export default function sideMenuReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_ACTIVE_MENU:
      return { ...state, activeMenu: action.payload };
    case SET_SIDE_MENU:
      return { ...state, ...action.payload };
    case SET_SIDE_NAV_OPEN:
      return { ...state, isSideNavOpen: action.payload };
    case SET_SIDE_NAV_COLLAPSIBLE:
      return { ...state, isSideNavCollapsible: action.payload };
    default:
      return state;
  }
}
